<template>
  <details class="ad-details">
    <summary class="ad-summary">Cómo se calculó esto</summary>
    <div class="ad-body">
      <div v-if="analysis && analysis.summary && analysis.summary.length">
        <p class="ad-subtitle">Resumen por modelo</p>
        <table class="ad-table">
          <thead>
            <tr>
              <th>Modelo</th>
              <th>R² ajustado</th>
              <th>Predictores</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in analysis.summary" :key="'summary-' + row.model">
              <td>{{ row.model }}</td>
              <td>{{ summaryR2(row) }}%</td>
              <td>{{ predictorsLabel(row.predictors) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </details>
</template>

<script>
import { getConditionLabel } from "./regression-helpers";

export default {
  name: "AnalysisDisclosure",
  props: {
    analysis: {
      type: Object,
      default: null,
    },
  },
  methods: {
    predictorsLabel(predictors) {
      if (!predictors || !predictors.length) return "—";
      return predictors.map(getConditionLabel).join(", ");
    },
    summaryR2(row) {
      if (!row || row.r_squared_adj == null) return "—";
      return Math.round(row.r_squared_adj * 100);
    },
  },
};
</script>

<style lang="scss" scoped>
.ad-details {
  margin-top: 6px;
  font-size: 0.78rem;
}

.ad-summary {
  cursor: pointer;
  color: #510087;
  font-weight: 600;
  outline: none;
}

.ad-body {
  margin-top: 8px;
}

.ad-subtitle {
  font-weight: 600;
  margin: 8px 0 4px;
  color: #4a4a4a;
}

.ad-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 8px;

  th,
  td {
    text-align: left;
    padding: 4px 8px;
    border-bottom: 1px solid #eee;
  }

  th {
    color: #7a7a7a;
    font-weight: 600;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/frpm/components/variables-prioritarias/AnalysisDisclosure.vue